import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { IconColor, IconSize } from '@freelancer/ui/icon';
import { LinkUnderline } from '@freelancer/ui/link';
import { FontColor, FontWeight } from '@freelancer/ui/text';

@Component({
  selector: 'app-navigation-menu-nav-item',
  template: `
    <fl-link
      [flTrackingLabel]="trackingLabel"
      [underline]="LinkUnderline.NEVER"
      [link]="url"
      [fragment]="fragment"
      [display]="'block'"
      [newTab]="false"
      (mouseenter)="onHover(true)"
      (click)="onClick(true)"
    >
      <div
        class="Container"
        tabindex="0"
        [class.IsActive]="isActive"
        [class.IsFlex]="isFlex"
        [class.IsLoggedOut]="isLoggedOut"
        [class.DoubleColumn]="doubleColumn"
      >
        <fl-icon
          *ngIf="!doubleColumn"
          class="IconColor Icon"
          [flMarginRight]="'xsmall'"
          [name]="iconName"
          [useIconFont]="useIconFont"
          [color]="IconColor.INHERIT"
          [size]="iconSize"
          [sizeTablet]="useIconFont ? IconSize.SMALL : IconSize.MID"
        ></fl-icon>
        <div class="Container-box">
          <div [flMarginRight]="'xsmall'">
            <div
              [class.SolutionsWrapper]="doubleColumn"
              [flMarginBottom]="isMobile ? 'none' : 'xxxsmall'"
            >
              <fl-icon
                *ngIf="doubleColumn"
                class="IconColor"
                [flMarginRight]="'xxsmall'"
                [name]="iconName"
                [useIconFont]="useIconFont"
                [color]="iconColor"
                [size]="useIconFont ? IconSize.XSMALL : IconSize.SMALL"
              ></fl-icon>
              <fl-text
                [color]="descriptionColor"
                [weight]="FontWeight.BOLD"
              >
                {{ titleLink }}
              </fl-text>
            </div>

            <fl-text
              [flHideMobile]="true"
              [color]="descriptionColor"
            >
              {{ description }}
            </fl-text>
          </div>
          <fl-icon
            *ngIf="iconArrow"
            [name]="'ui-chevron-right'"
            [useIconFont]="true"
            [fillIconFont]="true"
            [color]="iconArrowColor"
            [size]="IconSize.SMALL"
          ></fl-icon>
        </div>
      </div>
    </fl-link>
  `,
  styleUrls: ['./navigation-menu-nav-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationMenuNavItemComponent {
  FontWeight = FontWeight;
  IconColor = IconColor;
  IconSize = IconSize;
  LinkUnderline = LinkUnderline;

  @Input() url?: string;
  @Input() fragment?: string;
  @Input() trackingLabel = 'navigationItemLink';
  @Input() iconName: string;
  @Input() titleLink: string;
  @Input() description?: string;
  @Input() iconArrow = true;
  @Input() iconArrowColor = IconColor.FOREGROUND;
  @Input() contentId?: string;
  @Input() isActive = false;
  @Input() isFlex = false;
  @Input() useIconFont = true;
  @Input() iconSize = IconSize.SMALL;
  @Input() isMobile = false;
  @Input() descriptionColor = FontColor.FOREGROUND;
  @Input() isLoggedOut = false;

  /* To be use only on the solutions Callout */
  @Input() iconColor: IconColor = IconColor.INHERIT;
  @Input() doubleColumn = false;

  @Output() hover = new EventEmitter<string | undefined>();
  @Output() clicked = new EventEmitter<string | undefined>();

  onHover(isHovered: boolean): void {
    this.hover.emit(isHovered ? this.contentId : undefined);
  }

  onClick(isHovered: boolean): void {
    this.clicked.emit(isHovered ? this.contentId : undefined);
  }
}
